import { createVanIconComponent } from "./van"

const DeleteOutlined = createVanIconComponent("delete-o")
export default DeleteOutlined
